import { render } from "./PlayerFieldPosition.vue?vue&type=template&id=d06601de&scoped=true"
import script from "./PlayerFieldPosition.vue?vue&type=script&lang=js"
export * from "./PlayerFieldPosition.vue?vue&type=script&lang=js"

import "./PlayerFieldPosition.vue?vue&type=style&index=0&id=d06601de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d06601de"]])

export default __exports__